import { useUser } from '@auth0/nextjs-auth0';
import Loader from 'atoms/Loader';
import { getAuth } from 'services/auth.service';

const isBrowser = () => typeof window !== 'undefined';

const WithAuth = ({ router, children }) => {
    const { user, isLoading } = useUser();

    const unProtectedRoutes = ['/', '/error', '/termandcondition', '/product', '/regulatoryInfo/DeonRuleBook',
        '/liveprices', '/liveprices/[type]', '/liveprices/[type]/[subType]'];

    const isProtected = !unProtectedRoutes.includes(router.pathname);
    const redirectImgUrl = router.query.redirectImgUrl;

    if (isLoading) {
        return <Loader />;
    }

    const auth = getAuth();
    if (!auth?.id && redirectImgUrl) {
        try {
            if (isBrowser()) window.location.href = redirectImgUrl;
        } catch (err) {
            console.error('Invalid image URL', err);
        }
        return null;
    }

    if (isBrowser() && isProtected && (!user || !auth)) {
        router.replace('/');
        return null;
    }
    return children;
};

export default WithAuth;
